import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import {createLocationLink } from 'redux/location-links/actions';

import GooglePlacesAutocomplete,
  { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete';

import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import { GOOGLE_MAPS_API_KEY } from 'utils/restapi';

import './AddLocationLinkForm.css';


function AddLocationLinkForm(props) {
  const { me, createLocationLink, locationLinksList } = props;

  const { t } = useTranslation();

  const [currentValue, setCurrentValue] = useState(null);
  const [currentAddress, setCurrentAddress] = useState(null);
  const [currentLat, setCurrentLat] = useState(null);
  const [currentLng, setCurrentLng] = useState(null);

  useEffect(() => {
    if (currentValue) {
      geocodeByPlaceId(currentValue.value.place_id)
      .then(results => {
        setCurrentAddress(results[0].formatted_address);
        return getLatLng(results[0]);
      })
      .then(({ lat, lng }) => {
        setCurrentLat(lat);
        setCurrentLng(lng);
      })
      .catch(error => console.error(error));
    }
  }, [currentValue]);

  const clearValues = () => {
    setCurrentValue(null);
    setCurrentAddress(null);
    setCurrentLat(null);
    setCurrentLng(null);
  };

  const isPro = me && me.subscription && me.subscription.ff_maps;
  const disabledPro = isPro && locationLinksList && locationLinksList.length === 5;
  const disabledStarter = !isPro && locationLinksList && locationLinksList.length === 1;

  const isButtonDisabled = () => {
    if (!currentLat || !currentLng || !currentAddress) {
      return true;
    }
    if (disabledStarter) {
      return true;
    }
    if (disabledPro) {
      return true;
    }
    return false;
  };

  return (
    <div className="add-location-link-form__component">
      <div className="main-container">
        <div className="field-wrapper">
          <GooglePlacesAutocomplete
            apiKey={GOOGLE_MAPS_API_KEY}
            selectProps={{
              value: currentValue,
              onChange: setCurrentValue,
              placeholder: t("Type or paste location address"),
            }}
          />
        </div>
        <Button
          small
          onClick={() => {
            createLocationLink({
              title: currentAddress,
              lat: currentLat.toFixed(6),
              lng: currentLng.toFixed(6),
            });
            clearValues();
          }}
          disabled={isButtonDisabled()}
        >
          {t("Add Location")}
        </Button>
      </div>

      {disabledPro &&
        <CommonMessage warning>{t("You can not add more than 5 locations")}</CommonMessage>
      }

      {disabledStarter &&
        <CommonMessage warning>{t("You can not add more than 1 location")}</CommonMessage>
      }
    </div>
  );
}

AddLocationLinkForm.propTypes = {
  createLocationLink: PropTypes.func.isRequired,
  locationLinksList: PropTypes.arrayOf(PropTypes.shape),
  me: PropTypes.object,
};

AddLocationLinkForm.defaultProps = {
  locationLinksList: null,
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    locationLinksList: state.locationLinksReducer.locationLinksList,
  }
);

export default connect(
  mapStateToProps,
  {
    createLocationLink,
  },
)(AddLocationLinkForm);
